import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'developerPortalSupportAgent',
});

export const statusPageRouteRef = createRouteRef({
  id: 'developerPortalSupportAgent.statusPage',
});
